/**
 * @generated SignedSource<<17016d81d9fa4e266597043586e5c979>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type discoveryAiCreditsPurchaseDialogQuery$variables = {
  addonKey: string;
  baseCurrencyCode: string;
  currencyCode: string;
};
export type discoveryAiCreditsPurchaseDialogQuery$data = {
  readonly addon: {
    readonly rates: ReadonlyArray<{
      readonly feeValue: number;
      readonly rateID: number;
      readonly usageFrom: number;
    }>;
  } | null;
  readonly exchangeRates: {
    readonly rates: ReadonlyArray<{
      readonly code: string | null;
      readonly rate: number;
      readonly zeroDecimal: boolean;
    } | null> | null;
  };
};
export type discoveryAiCreditsPurchaseDialogQuery = {
  response: discoveryAiCreditsPurchaseDialogQuery$data;
  variables: discoveryAiCreditsPurchaseDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addonKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baseCurrencyCode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currencyCode"
},
v3 = [
  {
    "kind": "Variable",
    "name": "addonKey",
    "variableName": "addonKey"
  },
  {
    "kind": "Variable",
    "name": "currencyCode",
    "variableName": "currencyCode"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeValue",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageFrom",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateID",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "baseCurrencyCode",
      "variableName": "baseCurrencyCode"
    }
  ],
  "concreteType": "ExchangeRates",
  "kind": "LinkedField",
  "name": "exchangeRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExchangeRate",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zeroDecimal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "discoveryAiCreditsPurchaseDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "discoveryAiCreditsPurchaseDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "606cf5de90b3f3d965f603080aaf6b39",
    "id": null,
    "metadata": {},
    "name": "discoveryAiCreditsPurchaseDialogQuery",
    "operationKind": "query",
    "text": "query discoveryAiCreditsPurchaseDialogQuery(\n  $addonKey: String!\n  $currencyCode: String!\n  $baseCurrencyCode: String!\n) {\n  addon(addonKey: $addonKey, currencyCode: $currencyCode) {\n    rates {\n      feeValue\n      usageFrom\n      rateID\n      id\n    }\n    id\n  }\n  exchangeRates(baseCurrencyCode: $baseCurrencyCode) {\n    rates {\n      code\n      rate\n      zeroDecimal\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6577d2312f68ed7afed07322945c611d";

export default node;
